// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__MLw-X","content":"styles_content__xl-A6","description":"styles_description__jp5ra","recommendedSize":"styles_recommendedSize__jIDtQ"};